import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import theme from '../theme';
import { defaultScale, scaleText } from '../utils/scaling';
import { ProgressBar } from './ProgressBar';
import { IStrengthResult } from './selectors';

interface IProps {
  result: IStrengthResult;
}

export const SingleBodyGroupResultDisplay: React.FC<IProps> = ({ result }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.bodyGroupText}>{result.primaryMuscleMover}</Text>
      <ProgressBar
        fromValue={0}
        height={defaultScale(10)}
        toValue={result.value/100}
        containerStyle={{ flex: 1, marginHorizontal: defaultScale(15) }}
        color={result.color}
        hasBorderRadius={false}
      />
      <Text style={styles.valueText}>{result.value}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: '90%',
    marginBottom: defaultScale(10),
    justifyContent: 'center',
    margin: 'auto',
  },
  bodyGroupText: {
    fontFamily: theme.Custom400,
    color: theme.TEXT_DARK,
    textAlign: 'right',
    fontSize: scaleText(12),
    width: defaultScale(105),
    lineHeight: defaultScale(12),
  },
  valueText: {
    fontSize: scaleText(12),
    fontFamily: theme.Custom400,
    color: theme.TEXT_DARK,
    width: defaultScale(30),
    lineHeight: defaultScale(12),
  },
});
